var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeatWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23,
    viewBox: "0 0 30 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.27588C0 3.17131 0.89543 2.27588 2 2.27588H4C5.10457 2.27588 6 3.17131 6 4.27588V14.2759C6 15.3804 6.89543 16.2759 8 16.2759H22C23.1046 16.2759 24 15.3804 24 14.2759V4.27588C24 3.17131 24.8954 2.27588 26 2.27588H28C29.1046 2.27588 30 3.17131 30 4.27588V17.2759C30 20.0373 27.7614 22.2759 25 22.2759H5C2.23858 22.2759 0 20.0373 0 17.2759V4.27588Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.27588C7 1.61902 8.34315 0.275879 10 0.275879H20C21.6569 0.275879 23 1.61902 23 3.27588V14.2759C23 14.8282 22.5523 15.2759 22 15.2759H8C7.44772 15.2759 7 14.8282 7 14.2759V3.27588Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatWhite);
export default __webpack_public_path__ + "static/media/seatWhite.659bf1b782838707389b5ca3d799526d.svg";
export { ForwardRef as ReactComponent };